import React, {useState } from "react";
import { StyledCompanyContainer} from "../../../Components/Styled";
import SelectBoxWithLabel from "../../../Components/SelectBoxWithLable";
import TextFiledWithLabel from "../../../Components/TextFieldWithLabel";
import { Box } from "@mui/system";
import { StyledSubHeader } from "../../../Components/Styled";
import { useDispatch, useSelector } from "react-redux";
import { requestHideLoader, requestShowLoader } from "../../../Store/Global/action";
import { clientValidation, createRequestData,  getRequestData, updateRequestData } from "../../../Utility/apiHelper";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { ACTIVE_STATUS, CLIENT_DOC_TYPE, handleValidateCodevalue} from "../../../Utility/constant";
import AddressFields from "../../../Components/AddressFields";
import CommonComm from "../../../Components/CommonComm";
import CommonPoc from "../../../Components/CommonPoc";

import DocumentManagement from "../../../Components/DocumentManagement";
import BiztantuLoader from "../../../Components/Loader";


const CreateEditOrg = ({currentcompanyid}) => {
    
    
    const [isViewMode,setIsViewMode] = useState(true);
    const clientCOBData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == 'CLIENT_BUSINESS_CONSTITUTION')?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const clientNOBData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == 'CLIENT_BUSINESS_TYPE')?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const clientNOPData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == 'CLIENT_PREMISE_TYPE')?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const clientStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == 'CLIENT_STATUS')?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const docType = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == CLIENT_DOC_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);

    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const [userDetail, setUserdetails] = useState(
        {
            status : "CLIENT_STATUS_ACTIVE",
            state:"Other",
        })
    const [initialUserDetails,setInitialUserDetails] = useState(null);
    const [requiredValue, setRequiredvalue] = useState({
            clientCode:false,
            status : false,
            name:false,
            tradeName:false,
            constitutionOfBusiness:false,
            email: false,
            phone: false,
    })
    

    const {enqueueSnackbar} = useSnackbar();

    const dispatch = useDispatch();


    useEffect(() => {
        getcurrentuserdetails()
    },[currentcompanyid])

 


    const getcurrentuserdetails = async() => {
        dispatch(requestShowLoader())
        const url = `${process.env.REACT_APP_BASE_URL}companies/${currentcompanyid}`;
        const response = await getRequestData(url);
        const responseData = response?.data;
        setUserdetails({
            ...responseData,
            address :  responseData?.registeredAddress,
        });
        setInitialUserDetails({
            ...responseData,
            address :  responseData?.registeredAddress,
        });
        dispatch(requestHideLoader())
    }
    

    const resetRequiredState =()=>{
        setRequiredvalue({
            clientCode:true,
            status : true,
            name:true,
            tradeName:true,
            constitutionOfBusiness:true,
            email: true,
            phone: true,
        })
    }

    const handleSaveUser = async() => {
        const formData = new FormData();
        if(clientValidation(userDetail)) {
            dispatch(requestShowLoader());
            
            const reqObject = {
                ...userDetail,
                registeredAddress : userDetail?.address,
            }
            formData.append("client", JSON.stringify(reqObject));
            const url = `${process.env.REACT_APP_BASE_URL}companies`;
            const responseData = await createRequestData(formData, url , true);
            const error = responseData?.propererror?.data?.message
            if(responseData?.status == 200) {  

                const createdClientId = responseData?.data?.id;

                const copycodeurl = `${process.env.REACT_APP_BASE_URL}lookup/client/copyAllSystemLookupCodes`;

                const clientSystemResponse = await updateRequestData({clientId: createdClientId}, copycodeurl);

                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_CREATED_SUCCESSFULLY"), {variant: 'success'})
                // setUserdetails(null);
                dispatch(requestHideLoader());
                }
            else{
            dispatch(requestHideLoader());
            
            enqueueSnackbar(handleValidateCodevalue(internationalise,error || "COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
       } }
        else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS") , {variant:"error"})
            resetRequiredState()
        }
    }

    const handleupdateuser = async(value = false) => {
        if(JSON.stringify(userDetail) == JSON.stringify(initialUserDetails)){
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED") , {variant : 'info'});
        return;
    }
        const formData = new FormData();

        if(clientValidation(userDetail)) {
            dispatch(requestShowLoader());
            
            const reqObject = {
                ...userDetail,
                registeredAddress : userDetail?.address,
            }
            formData.append("client", JSON.stringify(reqObject));
        const url = `${process.env.REACT_APP_BASE_URL}companies/${currentcompanyid}`;
        const response = await updateRequestData(formData,url , true);
        const error = response?.propererror?.data?.error

        if(response?.status == 200) {
            const responseData = response?.data
            // dispatch(requestgetAllUser());
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPDATED_SUCCESSFULLY"), {variant: 'success'})
            setUserdetails({
            ...responseData,
            address :  responseData?.registeredAddress,
        });
        setInitialUserDetails({
            ...responseData,
            address :  responseData?.registeredAddress,
        });
        }
        else{
            enqueueSnackbar(handleValidateCodevalue(internationalise,error || "COMMON_PLEASE_TRY_AGAIN"),{variant:"error"})
        }
        dispatch(requestHideLoader());
    }
    else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS") , {variant:"error"})
        resetRequiredState()
    }
}


 const handleChangeCompanyDetails = (event) => {
     const { name, value} = event.target;
    setUserdetails({
        ...userDetail,
        [name]: value
    });
    };

        const handleSelectCustomer=(event, Customer)=>{
            setUserdetails({
                ...userDetail,
                selectedCustomer : Customer,
                customerId : Customer?.id
            })
    }

    const isLoadingProgress = useSelector(state => state?.global.isLoading); 
    return(
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
            <Box sx={{backgroundColor: '#F4F9FE'}}>
            <Box className="globalBox client-page">
                <StyledSubHeader>
                    {handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_DETAILS')}
                </StyledSubHeader>
                <StyledCompanyContainer>
                        <TextFiledWithLabel
                    required={false}
                    name= "id"
                    disabled="true"
                    value = {userDetail?.id}
                    label = {handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_ID')}
                    />
                    <TextFiledWithLabel
                        required={true}
                        name= "clientCode"
                        isViewMode = {isViewMode}
                        value= {userDetail?.clientCode}
                        error={userDetail?.clientCode ? false : requiredValue?.clientCode}
                        label={handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_CODE')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        name= "status"
                        disabled = {isViewMode}
                        value= {userDetail?.status || ""}
                        isStatic = {false}
                        optionMenuItem={clientStatusData}
                        label={handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_STATUS')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    <TextFiledWithLabel
                    sx = {{visibility : 'hidden'}}
                    />
                    </StyledCompanyContainer>
                    <StyledCompanyContainer >
                    <TextFiledWithLabel
                        required={true}
                        name= "name" 
                        isViewMode = {isViewMode}
                        error={userDetail?.name ? false : requiredValue?.name}
                        value= {userDetail?.name}
                        label= {handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_LN')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    <TextFiledWithLabel
                        required={true}
                        name= "tradeName"
                        isViewMode = {isViewMode}
                        value= {userDetail?.tradeName}
                        error={userDetail?.tradeName ? false : requiredValue?.tradeName}
                        label={handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_TN')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        required={true}
                        name= "constitutionOfBusiness"
                        isViewMode = {isViewMode}
                        value= {userDetail?.constitutionOfBusiness || ""}
                        isStatic= {false}
                        error={userDetail?.constitutionOfBusiness ? false : requiredValue?.constitutionOfBusiness}
                        optionMenuItem={clientCOBData}
                        label= {handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_COB')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    <TextFiledWithLabel
                    sx = {{visibility : 'hidden'}}
                    />
                    </StyledCompanyContainer>
                    <StyledCompanyContainer>
                    <SelectBoxWithLabel
                    ownerdropdown = {false}
                    name = "natureOfPremises"
                    isViewMode = {isViewMode}
                    value = {userDetail?.natureOfPremises || ""}
                    isStatic = {false}
                    optionMenuItem={clientNOPData}
                    label = {handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_NOP')}
                    onChange={handleChangeCompanyDetails}
                    />
                    
                    <SelectBoxWithLabel
                    ownerdropdown = {false}
                    sx={{marginRight:"200px" }}
                    name = "natureOfBusiness"
                    isViewMode = {isViewMode}
                    value = {userDetail?.natureOfBusiness || ""}
                    isStatic = {false}
                    optionMenuItem={clientNOBData}
                    label = {handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_NOB')}
                    onChange={handleChangeCompanyDetails}
                    />
                    <TextFiledWithLabel
                    sx = {{visibility : 'hidden'}}
                    />
                    <TextFiledWithLabel
                    sx = {{visibility : 'hidden'}}
                    />
                    
            </StyledCompanyContainer>
                <CommonComm
                required={true}
                requiredValue={requiredValue}
                isDetailPage = {true}
                isViewMode={isViewMode}
                handleOnChange={handleChangeCompanyDetails}
                state = {userDetail}
                />
                <AddressFields
                disabled = {isViewMode}
                entityDetails = {userDetail}
                setEntityDetails = {setUserdetails}
                onChange = {handleChangeCompanyDetails}
                />
                <CommonPoc
                required={false}
                isDetailPage={true}
                isViewMode={isViewMode}
                handleOnChange={handleChangeCompanyDetails}
                state={userDetail}
                />
               
                <StyledSubHeader>
                {handleValidateCodevalue(internationalise,'CONF_CLIENT_TAX_CALC_FIELD')}
                </StyledSubHeader>
                <StyledCompanyContainer>

                    <TextFiledWithLabel
                        name= "pan"
                        isViewMode = {isViewMode}
                        value= {userDetail?.pan}
                        label={handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_PAN')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    <TextFiledWithLabel
                        name= "sgstin"
                        isViewMode = {isViewMode}
                        value= {userDetail?.sgstin}
                        label={handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_SGST')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    <TextFiledWithLabel
                        name= "cgstin"
                        isViewMode = {isViewMode}
                        value= {userDetail?.cgstin}
                        label={handleValidateCodevalue(internationalise,'CONF_CLIENT_EDIT_CGST')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    <TextFiledWithLabel
                    sx = {{visibility : "hidden"}}
                    />
                    
                </StyledCompanyContainer>
                <DocumentManagement
                disableDownload = {false}
                entityType="clientId"
                url = {`${process.env.REACT_APP_BASE_URL}clientDocuments`}
                docType={docType}
                isViewMode={isViewMode}
                clientId = {currentcompanyid}/>

                    
                </Box>
            </Box>
            {/* <BiztantuFooterButton 
                headerLabel={isEdituser? handleValidateCodevalue(internationalise,"CONF_CLIENT_EDIT_TITLE_EDIT") : handleValidateCodevalue(internationalise,"CONF_CLIENT_EDIT_TITLE_CREATE")}
                setIsViewMode={setIsViewMode}
                isEdituser={isEdituser}
                handleActionButton2 = {()=>handleupdateuser(true)}
                actionlabel2 = {handleValidateCodevalue(internationalise,'COMMON_SAVE_AND_EXIT')}
                isViewMode = {isViewMode}
                isiconRequired={false}
                actionlabel={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                isBackbtnreq={true}
                handleCustomBackbutton={handleCustomBackbutton}
                redirecturl=""
                handleActionButton={ isEdituser ? handleupdateuser : handleSaveUser}
                backButtonLabel= {handleValidateCodevalue(internationalise,'COMMON_BACK')}
            /> */}
            </BiztantuLoader>
        
        
    )
}

export default CreateEditOrg;